import { z } from 'zod/v4'
import createComponentSchema from '../util/createComponentSchema'

const ProcessmodelSchema = createComponentSchema(
  'Processmodel',
  z.object({
    processmodelUuid: z.string().optional(),
    tokenUuid: z.string().optional(),
    returnUrl: z.string().optional(),
    returnOnFinish: z.boolean().optional()
  })
)

export default ProcessmodelSchema
